import { createSelector } from '@ngrx/store';

import { HotelsHomeModuleState } from '@hotels/hotels-home/store/state/hotels-home-module.state';
import { HotelsHomeUiModuleState } from '@hotels/hotels-home/store/state/hotels-home-ui-module.state';
import { hotelsHomeRootSelector } from '@hotels/hotels-home/store/selectors/hotels-home-root.selector';

export const getUIHotelsHomeState = createSelector(
  hotelsHomeRootSelector,
  (state: HotelsHomeModuleState) => state.ui
);

export const isLoadingPopularDestinations =
  createSelector(getUIHotelsHomeState, (state: HotelsHomeUiModuleState) => state.isLoadingPopularDestinationsReducer);
export const isLoadingPopularHotels =
  createSelector(getUIHotelsHomeState, (state: HotelsHomeUiModuleState) => state.isLoadingPopularHotelsReducer);
export const isLoadingPopularPlaces =
  createSelector(getUIHotelsHomeState, (state: HotelsHomeUiModuleState) => state.isLoadingPopularPlacesReducer);
